import { render, staticRenderFns } from "./RXSubscriptionsGrid.vue?vue&type=template&id=7c2f1921&scoped=true"
import script from "./RXSubscriptionsGrid.vue?vue&type=script&lang=ts"
export * from "./RXSubscriptionsGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f1921",
  null
  
)

export default component.exports